<!-- Overlay loading -->
<div
  *ngIf="isOverlayLoading"
  class="overlay d-flex align-items-center justify-content-center"
>
  <div class="spinner-border text-primary" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
</div>

<div class="d-flex flex-column flex-column-fluid">
  <div id="kt_app_content" class="app-content flex-column-fluid">
    <div id="kt_app_content_container" class="app-container container-fluid">
      <div class="row gx-5 gx-xl-10">
        <div class="card mb-5 mb-xl-8">
          <div class="card-header border-0 pt-5">
            <h3 class="card-title align-items-start flex-column">
              <span class="card-label fw-bold fs-3 mb-1">{{
                organizationId
                  ? ("editOrganization" | translate)
                  : ("createNewOrganization" | translate)
              }}</span>
            </h3>
          </div>
          <div class="card-body py-3">
            <form
              [formGroup]="organizationForm"
              (ngSubmit)="saveOrganization($event)"
            >
              <!-- Corporate Informations -->
              <div class="row mb-5 mt-5">
                <span class="card-label fw-bold fs-3 mb-6">{{
                  "corporateInformations" | translate
                }}</span>
                <!-- Name -->
                <div class="col-lg-3 col-md-4 col-sm-6 mb-6">
                  <div class="form-floating">
                    <input
                      formControlName="name"
                      type="text"
                      class="form-control"
                      id="inputName"
                      placeholder="{{ 'name' | translate }}"
                      required
                    />
                    <label for="inputName">{{ "name" | translate }}</label>
                    <div *ngIf="isControlInvalid('name')" class="text-danger">
                      <ng-container
                        *ngIf="
                          organizationForm.get('name')?.hasError('required')
                        "
                      >
                        {{ "nameRequired" | translate }}
                      </ng-container>
                      <ng-container
                        *ngIf="
                          !organizationForm.get('name')?.hasError('required') &&
                          organizationForm.get('name')?.hasError('onlyLetters')
                        "
                      >
                        {{ "nameMustContainOnlyLetters" | translate }}
                      </ng-container>
                    </div>
                  </div>
                </div>
                <!-- City -->
                <div class="col-lg-3 col-md-4 col-sm-6 mb-6">
                  <div class="form-floating">
                    <input
                      formControlName="city"
                      type="text"
                      class="form-control"
                      id="inputCity"
                      placeholder="{{ 'city' | translate }}"
                      required
                    />
                    <label for="inputCity">{{ "city" | translate }}</label>
                    <div *ngIf="isControlInvalid('city')" class="text-danger">
                      <ng-container
                        *ngIf="
                          organizationForm.get('city')?.hasError('required')
                        "
                      >
                        {{ "cityRequired" | translate }}
                      </ng-container>
                      <ng-container
                        *ngIf="
                          !organizationForm.get('city')?.hasError('required') &&
                          organizationForm.get('city')?.hasError('onlyLetters')
                        "
                      >
                        {{ "cityMustContainOnlyLetters" | translate }}
                      </ng-container>
                    </div>
                  </div>
                </div>
                <!-- Country -->
                <div class="col-lg-3 col-md-4 col-sm-6 mb-6">
                  <div class="form-floating">
                    <input
                      formControlName="country"
                      type="text"
                      class="form-control"
                      id="inputCountry"
                      placeholder="{{ 'country' | translate }}"
                      required
                    />
                    <label for="inputCountry">{{
                      "country" | translate
                    }}</label>
                    <div
                      *ngIf="isControlInvalid('country')"
                      class="text-danger"
                    >
                      <ng-container
                        *ngIf="
                          organizationForm.get('country')?.hasError('required')
                        "
                      >
                        {{ "countryRequired" | translate }}
                      </ng-container>
                      <ng-container
                        *ngIf="
                          !organizationForm
                            .get('country')
                            ?.hasError('required') &&
                          organizationForm
                            .get('country')
                            ?.hasError('onlyLetters')
                        "
                      >
                        {{ "countryMustContainOnlyLetters" | translate }}
                      </ng-container>
                    </div>
                  </div>
                </div>
                <!-- Address Line 1 -->
                <div class="col-lg-3 col-md-4 col-sm-6 mb-6">
                  <div class="form-floating">
                    <input
                      formControlName="adress"
                      type="text"
                      class="form-control"
                      id="inputAddressLine"
                      placeholder="{{ 'addressLine' | translate }}"
                      required
                    />
                    <label for="inputAddressLine">{{
                      "addressLine" | translate
                    }}</label>
                    <div *ngIf="isControlInvalid('adress')" class="text-danger">
                      <ng-container
                        *ngIf="
                          organizationForm.get('adress')?.hasError('required')
                        "
                      >
                        {{ "addressLineRequired" | translate }}
                      </ng-container>
                    </div>
                  </div>
                </div>
                <!-- Type of Organization -->
                <div class="col-lg-3 col-md-4 col-sm-6 mb-6">
                  <div class="form-floating">
                    <input
                      formControlName="typeOfOrganization"
                      type="text"
                      class="form-control"
                      id="inputTypeOfOrganization"
                      placeholder="{{ 'typeOfOrganization' | translate }}"
                      required
                    />
                    <label for="inputTypeOfOrganization">{{
                      "typeOfOrganization" | translate
                    }}</label>
                    <div
                      *ngIf="isControlInvalid('typeOfOrganization')"
                      class="text-danger"
                    >
                      <ng-container
                        *ngIf="
                          organizationForm
                            .get('typeOfOrganization')
                            ?.hasError('required')
                        "
                      >
                        {{ "typeOfOrganizationRequired" | translate }}
                      </ng-container>
                    </div>
                  </div>
                </div>
                <!-- Agb/Vat -->
                <div class="col-lg-3 col-md-4 col-sm-6 mb-6">
                  <div class="form-floating">
                    <input
                      formControlName="corporateAgbVAT"
                      type="text"
                      class="form-control"
                      id="inputAgbVat"
                      placeholder="Agb/Vat"
                      required
                    />
                    <label for="inputAgbVat">{{ "agbVat" | translate }}</label>
                    <div
                      *ngIf="isControlInvalid('corporateAgbVAT')"
                      class="text-danger"
                    >
                      <ng-container
                        *ngIf="
                          organizationForm
                            .get('corporateAgbVAT')
                            ?.hasError('required')
                        "
                      >
                        {{ "agbVatRequired" | translate }}
                      </ng-container>
                    </div>
                  </div>
                </div>
                <!-- Phone Number -->
                <div class="col-lg-3 col-md-4 col-sm-6 mb-6">
                  <div class="form-floating">
                    <input
                      formControlName="phone1"
                      type="tel"
                      class="form-control"
                      id="inputTel"
                      placeholder="{{ 'phoneNumber' | translate }}"
                    />
                    <label for="inputTel">{{
                      "phoneNumber" | translate
                    }}</label>
                    <div *ngIf="isControlInvalid('phone1')" class="text-danger">
                      <div
                        *ngIf="organizationForm.get('phone1')?.errors?.['required']"
                      >
                        {{ "phoneNumberRequired" | translate }}
                      </div>
                      <div
                        *ngIf="organizationForm.get('phone1')?.errors?.['pattern']"
                      >
                        {{ "phoneNumberNotValid" | translate }}
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Email -->
                <div class="col-lg-3 col-md-4 col-sm-6 mb-6">
                  <div class="form-floating">
                    <input
                      formControlName="email"
                      type="email"
                      class="form-control"
                      id="inputEmail"
                      placeholder="{{ 'email' | translate }}"
                    />
                    <label for="inputEmail">{{ "email" | translate }}</label>
                    <div *ngIf="isControlInvalid('email')" class="text-danger">
                      <div
                        *ngIf="organizationForm.get('email')?.errors?.['required']"
                      >
                        {{ "emailRequired" | translate }}
                      </div>
                      <div
                        *ngIf="organizationForm.get('email')?.errors?.['email']"
                      >
                        {{ "emailNotValid" | translate }}
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Location -->
                <div class="col-lg-3 col-md-4 col-sm-6 mb-6">
                  <div class="form-floating">
                    <input
                      formControlName="location"
                      type="text"
                      class="form-control"
                      id="inputLocation"
                      placeholder="{{ 'location' | translate }}"
                      required
                    />
                    <label for="inputLocation">{{
                      "location" | translate
                    }}</label>
                    <div
                      *ngIf="isControlInvalid('location')"
                      class="text-danger"
                    >
                      <ng-container
                        *ngIf="
                          organizationForm.get('location')?.hasError('required')
                        "
                      >
                        {{ "locationRequired" | translate }}
                      </ng-container>
                    </div>
                  </div>
                </div>
                <!-- Customer Code -->
                <div class="col-lg-3 col-md-4 col-sm-6 mb-6">
                  <div class="form-floating">
                    <input
                      formControlName="code"
                      type="text"
                      class="form-control"
                      id="inputCustomerCode"
                      placeholder="{{ 'customerCode' | translate }}"
                      required
                    />
                    <label for="inputCustomerCode">{{
                      "customerCode" | translate
                    }}</label>
                    <div *ngIf="isControlInvalid('code')" class="text-danger">
                      <ng-container
                        *ngIf="
                          organizationForm.get('code')?.hasError('required')
                        "
                      >
                        {{ "customerCodeRequired" | translate }}
                      </ng-container>
                    </div>
                  </div>
                </div>
                <!-- Application Selection -->
                <div class="col-lg-3 col-md-4 col-sm-6 mb-6">
                  <div class="form-floating">
                    <ngx-select-dropdown
                      formControlName="applications"
                      class="custom-select-input"
                      [options]="applications"
                      [instanceId]="'instance1'"
                      [multiple]="true"
                      [config]="dropdownConfig"
                      (change)="onApplicationSelect($event)"
                    >
                    </ngx-select-dropdown>
                    <div
                      *ngIf="isControlInvalid('applications')"
                      class="text-danger"
                    >
                      <ng-container
                        *ngIf="
                          organizationForm
                            .get('applications')
                            ?.hasError('required')
                        "
                      >
                        {{ "applicationSelectionRequired" | translate }}
                      </ng-container>
                    </div>
                  </div>
                </div>

                <!-- Language Selection -->
                <div class="col-lg-3 col-md-4 col-sm-6 mb-6">
                  <div class="form-floating">
                    <ngx-select-dropdown
                      formControlName="languageCode"
                      class="custom-select-input"
                      [options]="languages"
                      [instanceId]="'instance1'"
                      [multiple]="false"
                      [config]="languageDropdownConfig"
                    >
                    </ngx-select-dropdown>
                    <div
                      *ngIf="isControlInvalid('languageCode')"
                      class="text-danger"
                    >
                      <ng-container
                        *ngIf="
                          organizationForm
                            .get('languageCode')
                            ?.hasError('required')
                        "
                      >
                        {{ "languageSelectionRequired" | translate }}
                      </ng-container>
                    </div>
                  </div>
                </div>

                <!-- Which Language Apply Selection -->
                <div class="col-lg-3 col-md-4 col-sm-6 mb-6">
                  <div class="form-floating">
                    <ngx-select-dropdown
                      formControlName="applyHeadOfficeLanguage"
                      class="custom-select-input"
                      [options]="applyLanguageSelections"
                      [instanceId]="'instance1'"
                      [multiple]="false"
                      [config]="applyLanguageDropdownConfig"
                    >
                    </ngx-select-dropdown>
                    <div
                      *ngIf="isControlInvalid('applyHeadOfficeLanguage')"
                      class="text-danger"
                    >
                      <ng-container
                        *ngIf="
                          organizationForm
                            .get('applyHeadOfficeLanguage')
                            ?.hasError('required')
                        "
                      >
                        {{ "selectionRequired" | translate }}
                      </ng-container>
                    </div>
                  </div>
                </div>

                <!-- Time Difference -->
                <div class="col-lg-3 col-md-4 col-sm-6 mb-6">
                  <div class="form-floating">
                    <input
                      formControlName="timeDifference"
                      type="text"
                      class="form-control"
                      id="inputName"
                      placeholder="{{ 'timeDifference' | translate }}"
                      required
                      pattern="^([+-]?\d+)$"
                    />
                    <label for="inputName">{{
                      "timeDifference" | translate
                    }}</label>
                    <div
                      *ngIf="isControlInvalid('timeDifference')"
                      class="text-danger"
                    >
                      <ng-container
                        *ngIf="
                          organizationForm
                            .get('timeDifference')
                            ?.hasError('required')
                        "
                      >
                        {{ "timeDifferenceRequired" | translate }}
                      </ng-container>
                      <ng-container
                        *ngIf="
                          organizationForm
                            .get('timeDifference')
                            ?.hasError('pattern')
                        "
                      >
                        {{
                          "timeDifferenceMustContainOnlySignedNumber"
                            | translate
                        }}
                      </ng-container>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Billing Informations -->
              <div class="row mb-5 mt-5">
                <span class="card-label fw-bold fs-3 mb-6">{{
                  "billingInformations" | translate
                }}</span>
                <!-- Invoice Mail -->
                <div class="col-lg-3 col-md-4 col-sm-6 mb-6">
                  <div class="form-floating">
                    <input
                      formControlName="invoiceEmail"
                      type="email"
                      class="form-control"
                      id="inputInvoiceMail"
                      placeholder="{{ 'invoiceMail' | translate }}"
                      required
                    />
                    <label for="inputInvoiceMail">{{
                      "invoiceMail" | translate
                    }}</label>
                    <div
                      *ngIf="isControlInvalid('invoiceEmail')"
                      class="text-danger"
                    >
                      <div
                        *ngIf="organizationForm.get('invoiceEmail')?.errors?.['required']"
                      >
                        {{ "invoiceMailRequired" | translate }}
                      </div>
                      <div
                        *ngIf="organizationForm.get('invoiceEmail')?.errors?.['invoiceEmail']"
                      >
                        {{ "invoiceMailNotValid" | translate }}
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Billing Agb/Vat -->
                <div class="col-lg-3 col-md-4 col-sm-6 mb-6">
                  <div class="form-floating">
                    <input
                      formControlName="billingAgbVAT"
                      type="text"
                      class="form-control"
                      id="inputBillingAgbVat"
                      placeholder="Agb/Vat"
                      required
                    />
                    <label for="inputBillingAgbVat">{{
                      "agbVat" | translate
                    }}</label>
                    <div
                      *ngIf="isControlInvalid('billingAgbVAT')"
                      class="text-danger"
                    >
                      <ng-container
                        *ngIf="
                          organizationForm
                            .get('billingAgbVAT')
                            ?.hasError('required')
                        "
                      >
                        {{ "agbVatRequired" | translate }}
                      </ng-container>
                    </div>
                  </div>
                </div>
                <!-- Finance Department Mail -->
                <div class="col-lg-3 col-md-4 col-sm-6 mb-6">
                  <div class="form-floating">
                    <input
                      formControlName="financeDepartmentMail"
                      type="email"
                      class="form-control"
                      id="inputFinanceDeptMail"
                      placeholder="{{ 'financeDepartmentMail' | translate }}"
                      required
                    />
                    <label for="inputFinanceDeptMail">{{
                      "financeDepartmentMail" | translate
                    }}</label>
                    <div
                      *ngIf="isControlInvalid('financeDepartmentMail')"
                      class="text-danger"
                    >
                      <div
                        *ngIf="organizationForm.get('financeDepartmentMail')?.errors?.['required']"
                      >
                        {{ "financeDepartmentMailRequired" | translate }}
                      </div>
                      <div
                        *ngIf="organizationForm.get('financeDepartmentMail')?.errors?.['financeDepartmentMail']"
                      >
                        {{ "financeDepartmentMailNotValid" | translate }}
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Support Email -->
                <div class="col-lg-3 col-md-4 col-sm-6 mb-6">
                  <div class="form-floating">
                    <input
                      formControlName="supportEmail"
                      type="email"
                      class="form-control"
                      id="inputSupportEmail"
                      placeholder="{{ 'supportEmail' | translate }}"
                      required
                    />
                    <label for="inputSupportEmail">{{
                      "supportEmail" | translate
                    }}</label>
                    <div
                      *ngIf="isControlInvalid('supportEmail')"
                      class="text-danger"
                    >
                      <div
                        *ngIf="organizationForm.get('supportEmail')?.errors?.['required']"
                      >
                        {{ "supportMailRequired" | translate }}
                      </div>
                      <div
                        *ngIf="organizationForm.get('supportEmail')?.errors?.['supportEmail']"
                      >
                        {{ "supportMailNotValid" | translate }}
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Billing Location -->
                <div class="col-lg-2 col-md-4 col-sm-6 mb-6">
                  <div class="form-floating">
                    <input
                      formControlName="billingLocation"
                      type="text"
                      class="form-control"
                      id="inputBillingLocation"
                      placeholder="{{ 'location' | translate }}"
                      required
                    />
                    <label for="inputBillingLocation">{{
                      "location" | translate
                    }}</label>
                    <div
                      *ngIf="isControlInvalid('billingLocation')"
                      class="text-danger"
                    >
                      <ng-container
                        *ngIf="
                          organizationForm
                            .get('billingLocation')
                            ?.hasError('required')
                        "
                      >
                        {{ "locationRequired" | translate }}
                      </ng-container>
                    </div>
                  </div>
                </div>
                <!-- Billing State -->
                <div class="col-lg-2 col-md-4 col-sm-6 mb-6">
                  <div class="form-floating">
                    <input
                      formControlName="billingState"
                      type="text"
                      class="form-control"
                      id="inputBillingState"
                      placeholder="{{ 'state' | translate }}"
                      required
                    />
                    <label for="inputBillingState">{{
                      "state" | translate
                    }}</label>
                    <div
                      *ngIf="isControlInvalid('billingState')"
                      class="text-danger"
                    >
                      <ng-container
                        *ngIf="
                          organizationForm
                            .get('billingState')
                            ?.hasError('required')
                        "
                      >
                        {{ "stateRequired" | translate }}
                      </ng-container>
                    </div>
                  </div>
                </div>
                <!-- Billing Country -->
                <div class="col-lg-2 col-md-4 col-sm-6 mb-6">
                  <div class="form-floating">
                    <input
                      formControlName="billingCountry"
                      type="text"
                      class="form-control"
                      id="inputBillingCountry"
                      placeholder="{{ 'country' | translate }}"
                      required
                    />
                    <label for="inputBillingCountry">{{
                      "country" | translate
                    }}</label>
                    <div
                      *ngIf="isControlInvalid('billingCountry')"
                      class="text-danger"
                    >
                      <ng-container
                        *ngIf="
                          organizationForm
                            .get('billingCountry')
                            ?.hasError('required')
                        "
                      >
                        {{ "countryRequired" | translate }}
                      </ng-container>
                    </div>
                  </div>
                </div>
                <!-- Shipping address is the same as billing address -->
                <div class="col-md-4 col-sm-6 mb-6">
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      formControlName="isShippingAddressSameAsBilling"
                      id="isShippingAddressSameAsBilling"
                    />
                    <label
                      class="form-check-label"
                      for="isShippingAddressSameAsBilling"
                    >
                      {{
                        "shippingAddressIsTheSameAsBillingAddress" | translate
                      }}
                    </label>
                  </div>
                </div>
              </div>
              <!-- Sms Messages -->
              <div class="form-check">
                <input
                  formControlName="isActiveSmsMessages"
                  class="form-check-input"
                  type="checkbox"
                  value=""
                  id="isActiveSmsMessages"
                />
                <label class="form-check-label" for="isActiveSmsMessages">
                  {{ "smsMessages" | translate }}
                </label>
              </div>
              <!-- Using own Demoscope -->
              <div class="form-check mt-4">
                <input
                  formControlName="isUsingOwnDermascope"
                  class="form-check-input"
                  type="checkbox"
                  value=""
                  id="isUsingOwnDermascope"
                  checked
                />
                <label class="form-check-label" for="isUsingOwnDermascope">
                  {{ "usingOwnDemoscope" | translate }}
                </label>
              </div>
              <!-- Send Report to Patient -->
              <div class="form-check mt-4">
                <input
                  formControlName="sendReportToPatient"
                  class="form-check-input"
                  type="checkbox"
                  value=""
                  id="sendReportToPatient"
                />
                <label class="form-check-label" for="sendReportToPatient">
                  {{ "sendReportToPatient" | translate }}
                </label>
              </div>
              <div class="d-flex justify-content-end mt-8 gap-3">
                <button
                  [routerLink]="['/organization/list']"
                  type="button"
                  class="btn btn-sm btn-secondary cursor-pointer"
                >
                  {{ "cancel" | translate }}
                </button>
                <button
                  type="submit"
                  class="btn btn-sm btn-dark cursor-pointer"
                >
                  {{ "save" | translate }}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
